import { bindable, bindingMode, autoinject } from 'aurelia-framework';
import { I18N } from 'aurelia-i18n';

@autoinject
export class BankAccountType {
	@bindable({ defaultBindingMode: bindingMode.twoWay }) selectedBankAccountType: any;
	bankAccountTypes: any;

	constructor(private i18n:I18N) {
		this.bankAccountTypes = this.getBankAccountTypes();
	}

	getBankAccountTypes(): any {
		return [
			{
				value: "PersonalChecking",
				description: this.i18n.i18next.t('personalCheckingAccount',"Personal Checking Account")
			},
			{
				value: "PersonalSavings",
				description: this.i18n.i18next.t('personalSavingsAccount',"Personal Savings Account")
			},
			{
				value: "BusinessChecking",
				description: this.i18n.i18next.t('businessCheckingAccount',"Business Checking Account")
			}
		];
	}
}
